<p-confirmDialog key="inbox" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="inboxconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onViewReport()">View Report</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete Report</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDeleteAll()">Clear Inbox</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstInbox"
		[loading]="LoadingInbox"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedInbox"
		dataKey="InboxID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--JobDesc-->
				<th>
					<p-columnFilter type="text" field="JobDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Subject-->
				<th>
					<p-columnFilter type="text" field="Subject" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Body-->
				<th>
					<p-columnFilter type="text" field="Body" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--c_date-->
				<th>
					<p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--UnreadDesc-->
				<th>
					<p-columnFilter field="UnreadDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterUnreadDesc
								[ngModel]="value"
								[options]="lstUnreadDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="JobDesc">Report<p-sortIcon field="JobDesc"></p-sortIcon></th>
				<th pSortableColumn="Subject">Subject<p-sortIcon field="Subject"></p-sortIcon></th>
				<th pSortableColumn="Body">Body<p-sortIcon field="Body"></p-sortIcon></th>
				<th pSortableColumn="c_date">Date<p-sortIcon field="c_date"></p-sortIcon></th>
				<th pSortableColumn="Unread">Unread<p-sortIcon field="Unread"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Inbox>
			<tr [pSelectableRow]="Inbox" (dblclick)="onRowDblClick(Inbox)">
				<td
					*ngFor="let col of cols"
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.fontSize]="Inbox.Unread == true ? '14px' : '11px'"
				>
					{{ Inbox[col.field] }}
				</td>

				<td>
					<input [disabled]="IsLoading() == true" type="checkbox" class="CHK" [(ngModel)]="Inbox.Unread" (click)="onReadToggle(Inbox.InboxID)" />
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
